var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"transport-container"},[_vm._t("transport")],2),_c('div',{staticClass:"time-container"},[_vm._t("time")],2),_c('div',{staticClass:"list"},[_vm._t("list")],2),_c('div',{staticClass:"pay-container"},[_vm._t("pay")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }